import useSWR from "swr";
import { AppWindowMac } from "lucide-react";
import { AppType } from "@/types";
import { Template } from "@/types/template";
import { cn } from "@/lib/utils";

const appTypeLogos: Record<AppType, string | undefined> = {
  next: "/assets/app/nextjs.png",
  react: "/assets/app/react.png",
  "react-static": "/assets/app/react.png",
  "docker-compose": "/assets/app/docker.png",
  java: "/assets/app/java.svg",
  php: "/assets/app/php.png",
  deno: "/assets/app/deno.svg",
  bun: "/assets/app/bun.svg",
  native: undefined
};

const getAppLogo = ({
  appType,
  templateId,
  templateLogo
}: {
  appType?: AppType;
  templateId?: string;
  templateLogo?: string;
}) => {
  if (templateId && templateLogo) {
    return templateLogo;
  }

  if (appType) {
    return appTypeLogos[appType] ?? "";
  }

  return "";
};

export const AppLogo = ({
  appType,
  templateId,
  className,
  alt = "App logo",
  hideFallback = false
}: {
  appType?: AppType;
  templateId?: string;
  className?: string;
  alt?: string;
  hideFallback?: boolean;
}) => {
  const { data: template } = useSWR<Template>(
    templateId ? `/api/template/${templateId}` : null
  );
  const logo = getAppLogo({
    appType,
    templateId,
    templateLogo: template?.logo
  });

  if (logo) {
    return <img src={logo} alt={alt} className={cn("rounded-md object-contain", className)} />;
  }

  if (hideFallback) {
    return null;
  }

  return <AppWindowMac className={cn("shrink-0 text-foreground/60", className)} />;
};
